/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

// import { FeedbackHelpful } from "@simplicitycms/simplicity-forms";
import { FormProvider } from "@simplicitycms/simplicity-forms";
import { useSimpliCity } from "@simplicitycms/simplicity-common";
import { FeedbackHelpful } from "./feedback-helpful";

const FeedbackForm = (props) => {
    const { webpage, model, settings } = useSimpliCity();
    const component = props?.component;
    const url = window.location.href;
    const form_guid = settings?.feedback_form_guid;

    return (
        <>
            <FormProvider>
                <FeedbackHelpful
                    webpage={webpage}
                    model={model}
                    component={component}
                    urls={url}
                    form_guid={form_guid}
                />
            </FormProvider>
        </>
    );
};

FeedbackForm.displayName = "FeedbackForm";
export { FeedbackForm };
